import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sampleState: 'test',
    customerDetails: null,
    sessionDetails: null,
    quoteDetails: null,
    previousPolicyDetails: null,
    companyDetails: null,
    stripePublishableKey: null,
    termsAndConditionsAccepted: false,
    sessionEmail: null,
    onlineRenewalQuoteReferenceId: null,
    onlineRenewalEmail: null,
    onlineRenewalPaymentTerms: null,
    onlineRenewalStep: 1,
    onlineRenewalPaymentSuccess: false,

    /**
     * STORED DATA FOR PURCHASE ONLINE INSURANCE
     */
    isAllowedToCreateNewBusiness: false,

    NewBusinessStep: 1,
    NewBusinessHasValidNSWAddressAndAssignedToRisk: false,
    NewBusinessSessionStateIsLocked: false,
    NewBusinessServiceDialog: false,
    NewBusinessIsBusinessExemption: false,
    NewBusinessFullNameSimilar: true,

    NewBusinessToken: document.getElementsByName('cmb-api-token')[0].content,
    NewBusinessTokenName: "cmb-auth",
    NewBusinessUserType: "educator",
    NewBusinessEducatorInformationDateOfBirth: null,
    NewBusinessID: null,
    NewBusinessPolicyID: null,
    NewBusinessUserID: null,
    NewBusinessAdminID: null,
    NewBusinessEndorsementID: null,
    NewBusinessSessionQuoteReferenceID: null,
    NewBusinessSeqNo: null,
    NewBusinessPolicyNo: null,
    NewBusinessMemberNo: null,
    NewBusinessEducatorInformationEmailAddress: null,
    NewBusinessPlLimit: null,
    NewBusinessEducatorInformationFirstName: null,
    NewBusinessEducatorInformationLastName: null,
    NewBusinessBusinessName: null,
    NewBusinessGSTABNNumber: null,
    NewBusinessAddressSavedAddresses: [],
    NewBusinessEducatorInformationLandlineNumber: null,
    NewBusinessEducatorInformationMobileNumber: null,
    NewBusinessBusinessPhone: null,
    NewBusinessParentOrgranizationCustomer: null,
    NewBusinessOutstandingClaims: null,
    NewBusinessPreviousClaims: null,
    NewBusinessPreviousPolicies: null,
    NewBusinessIsRegisteredGST: true,
    NewBusinessSmallBusinessDisclaimer: true,
    NewBusinessAdditionalCover: null,
    NewBusinessAdditionalCoverCode: null,
    NewBusinessCoordinationUnit: null,
    NewBusinessPolicyPremiumTotal: null,
    NewBusinessAmountExceedFlag: null,
    NewBusinessTermsAgreementFlag: null,
    NewBusinessLastStep: null,
    NewBusinessQualifiedFlag: null,
    NewBusinessAbandonLogFlag: null,
    NewBusinessPolicyStatus: null,
    NewBusinessPolicyType: null,
    NewBusinessSessionStatus: "draft",
    NewBusinessTransactionType: "New Policy",
    NewBusinessAmmendmentDescription: "New Policy",
    NewBusinessCoverPackageCode: null,
    NewBusinessCoverPackageLabel: null,
    NewBusinessNumberOfEducators: null,
    NewBusinessCoverages: null,
    NewBusinessSchemeCoverages: null,
    NewBusinessLoi: null,
    NewBusinessInsuredName: null,
    NewBusinessInsuredAddress: [],
    NewBusinessIsDeleted: false,
    NewBusinessEvidenceOfInsuranceURL: null,
    NewBusinessFinancialServicesGuideURL: null,
    NewBusinessLetterOfCancellationURL: null,
    NewBusinessOfficialReceiptAbdTaxInvoiceURL: null,
    NewBusinessDualEducators: [],
    NewBusinessReliefEducators: [],
    NewBusinessSavedServices: undefined,
    NewBusinessUseFullNameAsBusinessName: false,
    NewBusinessInterestedParties: [],
    NewBusinessExistingClaims: null,
    NewBusinessPostAllDocuments: false,
    NewBusinessActivities: [],
    NewBusinessPolicyTerm: "12 months",
    NewBusinessPaymentTerms: "annual",
    NewBusinessIncludeMembership: true,
    NewBusinessPersonalAccident: true,
    NewBusinessAdditionalBranches: [],
    NewBusinessCompanyID: null,
    NewBusinessCustmomerID: null,
    NewBusinessGenerateInsuranceDocs: false,
    NewBusinessGenerateMembershipDocs: false,
    NewBusinessGenerateCancellationDocs: false,
    NewBusinessEmailInsuranceDocs: false,
    NewBusinessEmailMembershipDoc: false,
    NewBusinessEmailCancellationDocs: false,
    NewBusinessDueForRenewal: false,
    NewBusinessDoNotRenew: false,
    NewBusinessAdminFee: 0,
    NewBusinessAdminFeeGST: 0,
    NewBusinessSuppressDocuments: false,
    NewBusinessSessionID: null,
    NewBusinessQuoteID: null,
    NewBusinessAdditionalBranchesCount: 0,
    NewBusinessPolicyStart: null, //moment().format('YYYY-MM-DD'),
    NewBusinessPolicyExpiry: null, //moment().add('years', 1).subtract('days', 1).format('YYYY-MM-DD'),

    NewBusinessTotalCostPaymentTerm: 'annual',

    DisplayDateFormat: 'DD/MM/YYYY',
    DisplaySavedFormat: 'YYYY-MM-DD',

    NewBusinessStoreAddonsMatrix: null,
    NewBusinessStoreMembershipMatrix: null,
    NewBusinessStoreEducatorPLMatrix: null,
    NewBusinessStoreEducatorPAMatrix: null,

    debug: false,
    env: "",
    userId: ""
  },
  getters: {
    getState: state => name => {
      const property_arr = name.split(".")
      let stateValue = state[property_arr[0]]
      if (property_arr.length > 1) {
        for(let i = 0; i < property_arr.length; i++){
          state[property_arr[i]] = { ...state[property_arr[i]] }
          if (i === (property_arr.length - 1)){
            let value = state[property_arr[i]]
            stateValue = value && typeof value === 'object' && value.constructor === Object
              ? !! Object.keys(value)["length"] ? value : null
              : null
          }
        }
      }
      return stateValue
    },
    sessionPayload: state => {  
      return {  
        token:                                  state.NewBusinessToken,
        token_name:                             state.NewBusinessTokenName,
        user_type:                              state.NewBusinessUserType,
        date_of_birth:                          state.NewBusinessEducatorInformationDateOfBirth,
        id:                                     state.NewBusinessID,
        policy_id:                              state.NewBusinessPolicyID,
        user_id:                                state.NewBusinessUserID,
        admin_id:                               state.NewBusinessAdminID,
        endorsement_id:                         state.NewBusinessEndorsementID,
        session_quote_reference_id:             state.NewBusinessSessionQuoteReferenceID,
        seq_no:                                 state.NewBusinessSeqNo,
        policy_no:                              state.NewBusinessPolicyNo,
        member_no:                              state.NewBusinessMemberNo,
        email:                                  state.NewBusinessEducatorInformationEmailAddress,
        pl_limit:                               state.NewBusinessPlLimit,
        first_name:                             state.NewBusinessEducatorInformationFirstName,
        last_name:                              state.NewBusinessEducatorInformationLastName,   
        business_name:                          state.NewBusinessBusinessName,
        abn:                                    state.NewBusinessGSTABNNumber,
        addresses:                              state.NewBusinessAddressSavedAddresses,
        home_phone_number:                      state.NewBusinessEducatorInformationLandlineNumber,
        mobile_phone_number:                    state.NewBusinessEducatorInformationMobileNumber,
        business_phone:                         state.NewBusinessBusinessPhone,
        parent_organisation_customer:           state.NewBusinessParentOrgranizationCustomer,
        outstanding_claims:                     state.NewBusinessOutstandingClaims,
        previous_claims:                        state.NewBusinessPreviousClaims,
        previous_policies:                      state.NewBusinessPreviousPolicies,
        registered_for_gst:                     state.NewBusinessIsRegisteredGST,
        small_business_disclaimer:              state.NewBusinessSmallBusinessDisclaimer,
        additional_cover:                       state.NewBusinessAdditionalCover,
        additional_cover_code:                  state.NewBusinessAdditionalCoverCode,
        coordination_unit:                      state.NewBusinessCoordinationUnit,
        policy_premium_total:                   state.NewBusinessPolicyPremiumTotal,
        amount_exceed_flag:                     state.NewBusinessAmountExceedFlag,
        terms_agreement_flag:                   state.NewBusinessTermsAgreementFlag,
        last_step:                              state.NewBusinessLastStep,
        qualified_flag:                         state.NewBusinessQualifiedFlag,
        abandon_log_flag:                       state.NewBusinessAbandonLogFlag,
        policy_status:                          state.NewBusinessPolicyStatus,
        policy_type:                            state.NewBusinessPolicyType,
        session_status:                         state.NewBusinessSessionStatus,
        transaction_type:                       state.NewBusinessTransactionType,
        amendment_description:                  state.NewBusinessAmmendmentDescription,
        package:                                state.NewBusinessCoverPackageLabel,
        package_code:                           state.NewBusinessCoverPackageCode,
        number_of_educators:                    state.NewBusinessNumberOfEducators,
        coverages:                              state.NewBusinessCoverages,
        scheme_coverages:                       state.NewBusinessSchemeCoverages,
        loi:                                    state.NewBusinessLoi,
        insured_name:                           state.NewBusinessInsuredName,
        insured_address:                        state.NewBusinessInsuredAddress,
        is_deleted:                             state.NewBusinessIsDeleted,
        evidence_of_insurance_url:              state.NewBusinessEvidenceOfInsuranceURL,
        financial_services_guide_url:           state.NewBusinessFinancialServicesGuideURL,
        letter_of_cancellation_url:             state.NewBusinessLetterOfCancellationURL,
        official_receipt_and_tax_invoice_url:   state.NewBusinessOfficialReceiptAbdTaxInvoiceURL,
        dual_educators:                         state.NewBusinessDualEducators,
        relief_educators:                       state.NewBusinessReliefEducators,
        registered_service:                     state.NewBusinessSavedServices,
        use_full_name_as_business_name:         state.NewBusinessUseFullNameAsBusinessName,
        interested_parties:                     state.NewBusinessInterestedParties,
        existing_claims:                        state.NewBusinessExistingClaims,
        post_all_documents:                     state.NewBusinessPostAllDocuments,
        activities:                             state.NewBusinessActivities,
        policy_term:                            state.NewBusinessPolicyTerm,
        payment_terms:                          state.NewBusinessPaymentTerms,
        include_membership:                     state.NewBusinessIncludeMembership,
        include_personal_accident:              state.NewBusinessPersonalAccident,
        additional_branches:                    state.NewBusinessAdditionalBranches,
        company_id:                             state.NewBusinessCompanyID,
        customer_id:                            state.NewBusinessCustmomerID,
        generate_insurance_docs:                state.NewBusinessGenerateInsuranceDocs,
        generate_membership_doc:                state.NewBusinessGenerateMembershipDocs,
        generate_cancellation_docs:             state.NewBusinessGenerateCancellationDocs,
        email_insurance_docs:                   state.NewBusinessEmailInsuranceDocs,
        email_membership_doc:                   state.NewBusinessEmailMembershipDoc,
        email_cancellation_docs:                state.NewBusinessEmailCancellationDocs,
        due_for_renewal:                        state.NewBusinessDueForRenewal,
        do_not_renew:                           state.NewBusinessDoNotRenew,
        admin_fee:                              state.NewBusinessAdminFee,
        admin_fee_gst:                          state.NewBusinessAdminFeeGST,
        suppress_documents:                     state.NewBusinessSuppressDocuments,
        session_id:                             state.NewBusinessSessionID,
        quote_id:                               state.NewBusinessQuoteID,
        additional_branches_count:              state.NewBusinessAdditionalBranchesCount,
        policy_start:                           state.NewBusinessPolicyStart,
        policy_expiry:                          state.NewBusinessPolicyExpiry
      }
    }
  },
  mutations: {
    mutate(state, payload) {
      const property = payload.property
      const property_arr = property.split(".")

      if (property_arr.length === 1){
        if (property === 'sessionDetails.mailing_address') console.debug('if', payload)
        state[payload.property] = payload.value;
      }
      
      else {
        switch(property_arr.length){
          case 2:
            state[property_arr[0]] = { ...state[property_arr[0]] }
            state[property_arr[0]][property_arr[1]] = payload.value
            if (property === 'sessionDetails.mailing_address'){
              console.debug('case 2 0', state[property_arr[0]]);
              console.debug('case 2 1', state[property_arr[0]][property_arr[1]])
            }
          case 3:
            state[property_arr[0]] = { ...state[property_arr[0]] }
            state[property_arr[0]][property_arr[1]] = { ...state[property_arr[0]][property_arr[1]] }
            state[property_arr[0]][property_arr[1]][property_arr[2]] = payload.value
            if (property === 'sessionDetails.properties.mailing_address') {
              console.debug('case 3 0', state[property_arr[0]]);
              console.debug('case 3 1', state[property_arr[0]][property_arr[1]])
            }
        }
      }
    }
  },
  actions: {
    async fetchData({ rootState, commit }, payload) {

      let config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      },
      returnValue;
      switch(payload.method) {
        case 'get':
          config.params = payload.params;
          returnValue = axios.get(payload.url, config);
        break;
        
        case 'put':
          returnValue = axios.put(payload.url, payload.data);
        break;

        case 'post':
          returnValue = axios.post(payload.url, payload.data);
        break;

        case 'delete':
            config.params = payload.params;
          returnValue = axios.delete(payload.url);
        break;
      }
      return returnValue;

    },
    async quoteDetails({commit, state }, request){
      let request_addons = await request["method"]('add_ons', request["payload"]);
      let response_educator_pl = await request["method"]('educator_pl', request["payload"]);
      let response_educator_pa = await request["method"]('educator_pa', request["payload"]);

      let build_payload = { 
          properties: { 
              output_membership_base: '20',
              output_membership_base_gst: '30',
              output_pl_base: response_educator_pl[0].properties.output_pl_base,
              output_pl_base_gst: response_educator_pl[0].properties.output_pl_base_gst,
              output_pa_base: response_educator_pa[0].properties.output_pa_base,
              output_pa_base_gst: response_educator_pa[0].properties.output_pa_base_gst,
              addons_base: request_addons[0].properties.addons_base,
              addons_base_gst: request_addons[0].properties.addons_base_gst,
              additional_branches_total_fee: '100',
              output_pa_broker: response_educator_pa[0].properties.output_pa_broker,
              output_pa_broker_gst: response_educator_pa[0].properties.output_pa_broker_gst,
              output_pl_broker: response_educator_pl[0].properties.output_pl_broker,
              output_pl_broker_gst: response_educator_pl[0].properties.output_pl_broker_gst,
              activities_total_premium: '100',
              output_pa_stamp_duty: response_educator_pa[0].properties.output_pa_stamp_duty,
              output_pl_stamp_duty: response_educator_pl[0].properties.output_pl_stamp_duty,
              activities_broker_fee: '100'
          }
      } 

      commit('mutate', {
          property: 'quoteDetails',
          value: build_payload
      });

    }
  }
})
